import { toast } from 'sonner';
import type { UndeliveredCopy } from '@/hooks/useCredentials';

/**
 * After a save that some gateways missed, say which and why. The save stands:
 * at least one gateway took its copy (otherwise nothing is saved), and each one
 * that missed is recorded as not holding it, so replication brings it a copy
 * from a gateway that did on its next credential report. Gateways report about
 * every 5 minutes and whenever they connect.
 */
export function warnUndelivered(saved: string, undelivered: readonly UndeliveredCopy[] | undefined): void {
  if (!undelivered || undelivered.length === 0) return;
  const which = undelivered.length === 1 ? 'one gateway' : `${String(undelivered.length)} gateways`;
  const reasons = undelivered.map((u) => `${u.gatewayName}: ${u.reason}.`).join(' ');
  const catchUp =
    undelivered.length === 1
      ? 'It will get it from another gateway in the region within about 5 minutes, or when it next connects.'
      : 'They will get it from another gateway in the region within about 5 minutes, or when they next connect.';
  toast.warning(`${saved}, but ${which} didn't take it yet`, {
    description: `${reasons} ${catchUp}`,
    duration: 15_000,
  });
}
